import { ThemedTitle } from '@refinedev/antd';

import { useUiContext } from '@/contexts/UiContext';
import acronex_logo from '@/img/acronex-logo.svg';
import acronex_logo_lg from '@/img/acronex-logo-lg.svg';

interface AcronexThemedTitleProps {
  customWidth?: number;
}
const AcronexThemedTitle = (props: AcronexThemedTitleProps) => {
  const { customWidth } = props;
  const { isMediumScreen, openSider } = useUiContext();

  return (
    <ThemedTitle
      text=""
      icon={
        <img
          style={{
            width: customWidth ? customWidth : isMediumScreen ? 120 : openSider ? 120 : 32,
          }}
          src={isMediumScreen ? acronex_logo_lg : openSider ? acronex_logo_lg : acronex_logo}
        />
      }
      collapsed={!openSider}
    />
  );
};

export default AcronexThemedTitle;
